export var MenuStates;
(function (MenuStates) {
    MenuStates["RecentActivity"] = "/recent-activity";
    MenuStates["ProjectsWorkspace"] = "/projects-workspace";
})(MenuStates || (MenuStates = {}));
